<div
  #toggleButton
  (click)="toggleAll()"
  [ngClass]="{ selected: gridApi.zitiAllToggled }"
  class="tSelect tSelectHeader"
  id="RowSelect_Header"
></div>
